import NewAnnotation from "./NewAnnotation";
import NewResourceAnnotation from "./ResourceAnnotation";
import ViewAnnotations from "./ViewAnnotations";
import Citation from "./Citation";

export default {
  NewAnnotation,
  NewResourceAnnotation,
  ViewAnnotations,
  Citation
};

export { default as DisplaySelectModal } from "./ResourceAnnotation/DisplaySelectModal";
